import { COMMIT, DID } from 'app/constants/identityActions'
import {
  ALREADY_COMMITED,
  ALREADY_DID,
  ALREADY_SELECTED_NEW_PROTRACK,
  ALREADY_USED_LOGIN_LINK,
  INVALID_TOKEN,
} from 'app/constants/toastrMessages'
import { INVALID_TOKEN_PARAM, SELECT_NEW_PROTRACK_PARAM } from 'app/constants/loginErrors'

export const detectValidationErrors = errors => (errors.length && !!errors[0].property) || null

export const selectLoginErrorMessage = param => {
  switch (param) {
    case DID:
      return ALREADY_DID
    case COMMIT:
      return ALREADY_COMMITED
    case SELECT_NEW_PROTRACK_PARAM:
      return ALREADY_SELECTED_NEW_PROTRACK
    case INVALID_TOKEN_PARAM:
      return INVALID_TOKEN
    default:
      return ALREADY_USED_LOGIN_LINK
  }
}
/**
 * @deprecated
 */
export const detectDBErrors = errors => (errors.length && !!errors[0].path) || null

export const parseValidationErrors = errors => {
  return errors.reduce((acc, error) => {
    const { constraints, children } = error
    acc[error.property] = constraints
      ? Object.keys(constraints)
          .map(key => constraints[key].substring(constraints[key].indexOf(' ') + 1))
          .join(', ')
      : parseValidationErrors(children)
    return acc
  }, {})
}

/**
 * @deprecated
 */
export const parseDBErrors = errors =>
  errors.reduce((acc, error) => {
    const { message } = error
    acc[error.path] = message.substring(message.indexOf(' ') + 1)
    return acc
  }, {})

/**
 * @deprecated Please use parseValidationErrors instead
 */
export const parseSubmissionErrors = errors => {
  const response = detectValidationErrors(errors)
    ? parseValidationErrors(errors)
    : detectDBErrors(errors) ? parseDBErrors(errors) : null
  return response
}
